/* BRILUNA — scripts propios (vanilla, sin librerías) */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Aparición al hacer scroll ---------- */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.bl-reveal:not(.bl-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('bl-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('bl-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Cifras que cuentan ---------- */
  function initCifras(root) {
    var els = (root || document).querySelectorAll('[data-bl-contar]');
    if (!els.length) return;
    function pinta(el) {
      var fin = parseFloat(el.getAttribute('data-bl-contar')) || 0;
      var dec = (el.getAttribute('data-bl-contar').split('.')[1] || '').length;
      var pre = el.getAttribute('data-bl-prefijo') || '';
      var suf = el.getAttribute('data-bl-sufijo') || '';
      if (reduce) { el.textContent = pre + fin.toFixed(dec).replace('.', ',') + suf; return; }
      var t0 = null, dur = 1600;
      function paso(t) {
        if (!t0) t0 = t;
        var p = Math.min((t - t0) / dur, 1);
        var v = fin * (1 - Math.pow(1 - p, 3));
        el.textContent = pre + v.toFixed(dec).replace('.', ',') + suf;
        if (p < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(pinta); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { pinta(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.5 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Escena sticky: cambia la foto según el paso ---------- */
  function initEscenas(root) {
    (root || document).querySelectorAll('[data-bl-escena]').forEach(function (esc) {
      var pasos = esc.querySelectorAll('.bl-paso');
      var imgs = esc.querySelectorAll('.bl-escena__visual img');
      var hora = esc.querySelector('.bl-escena__hora');
      if (!pasos.length) return;
      function activa(i) {
        pasos.forEach(function (p, k) { p.classList.toggle('is-activo', k === i); });
        imgs.forEach(function (im, k) { im.classList.toggle('is-activa', k === i); });
        if (hora) hora.textContent = pasos[i].getAttribute('data-hora') || '';
      }
      activa(0);
      if (!('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) activa(Array.prototype.indexOf.call(pasos, e.target));
        });
      }, { rootMargin: '-45% 0px -45% 0px' });
      pasos.forEach(function (p) { io.observe(p); });
    });
  }

  /* ---------- Hero: aura que sigue suavemente al cursor ---------- */
  function initHero(root) {
    if (reduce) return;
    (root || document).querySelectorAll('.bl-hero').forEach(function (h) {
      var aura = h.querySelector('.bl-hero__aura');
      if (!aura || window.matchMedia('(hover: none)').matches) return;
      h.addEventListener('mousemove', function (ev) {
        var r = h.getBoundingClientRect();
        var x = (ev.clientX - r.left) / r.width - 0.5;
        var y = (ev.clientY - r.top) / r.height - 0.5;
        aura.style.transform = 'translate(' + (x * 40) + 'px,' + (y * 40) + 'px)';
      });
    });
  }

  /* ---------- Página de producto: galería + variantes ---------- */
  function initProducto(root) {
    (root || document).querySelectorAll('[data-bl-producto]').forEach(function (pp) {
      /* Galería */
      var principales = pp.querySelectorAll('.bl-pp__principal img');
      var minis = pp.querySelectorAll('.bl-pp__mini');
      var actual = 0;
      function cargaFoto(im) {
        if (!im || !im.hasAttribute('data-src')) return;
        if (im.getAttribute('data-srcset')) im.srcset = im.getAttribute('data-srcset');
        im.src = im.getAttribute('data-src');
        im.removeAttribute('data-src'); im.removeAttribute('data-srcset');
      }
      /* El resto de fotos de la galería se descargan en cuanto el cliente toca o pasa por la galería */
      var galeria = pp.querySelector('.bl-pp__galeria');
      var cargaResto = function () { principales.forEach(cargaFoto); };
      if (galeria) ['pointerenter', 'touchstart', 'focusin'].forEach(function (ev) { galeria.addEventListener(ev, cargaResto, { once: true, passive: true }); });
      function verFoto(i) {
        if (!principales.length) return;
        actual = (i + principales.length) % principales.length;
        cargaFoto(principales[actual]);
        cargaFoto(principales[(actual + 1) % principales.length]);
        principales.forEach(function (im, k) { im.classList.toggle('is-activa', k === actual); });
        minis.forEach(function (m, k) { m.classList.toggle('is-activa', k === actual); });
        if (minis[actual]) minis[actual].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }
      minis.forEach(function (m, k) { m.addEventListener('click', function () { verFoto(k); }); });
      var prev = pp.querySelector('.bl-pp__flecha--prev');
      var next = pp.querySelector('.bl-pp__flecha--next');
      if (prev) prev.addEventListener('click', function () { verFoto(actual - 1); });
      if (next) next.addEventListener('click', function () { verFoto(actual + 1); });
      var zona = pp.querySelector('.bl-pp__principal');
      if (zona) {
        var x0 = null;
        zona.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        zona.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 40) verFoto(actual + (dx < 0 ? 1 : -1));
          x0 = null;
        });
      }

      var formato = pp.getAttribute('data-bl-moneda') || '{{amount_with_comma_separator}} €';
      function dinero(c) {
        var n = (c / 100).toFixed(2);
        var coma = n.replace('.', ',');
        return formato
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, coma)
          .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, coma.split(',')[0])
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, n.split('.')[0])
          .replace(/\{\{\s*amount\s*\}\}/, n);
      }

      /* Packs de 1, 2 y 3: recalcula totales y muestra el del pack elegido en la barra móvil */
      var packs = pp.querySelector('[data-bl-packs]');
      var precioPacks = packs ? parseInt(packs.getAttribute('data-precio'), 10) : 0;
      function pintaPacks(precioUd) {
        if (!packs) return;
        if (precioUd != null) precioPacks = precioUd;
        var elegido = null;
        packs.querySelectorAll('[data-bl-pack]').forEach(function (l) {
          var n = parseInt(l.getAttribute('data-n'), 10);
          var pct = parseInt(l.getAttribute('data-pct'), 10) || 0;
          var sin = precioPacks * n;
          var unidad = Math.round(precioPacks * (100 - pct) / 100); /* Shopify redondea cada unidad */
          var tot = unidad * n;
          var desc = sin - tot;
          var q = function (s) { return l.querySelector(s); };
          if (q('[data-bl-pack-total]')) q('[data-bl-pack-total]').textContent = dinero(tot);
          if (q('[data-bl-pack-antes]')) q('[data-bl-pack-antes]').textContent = dinero(sin);
          if (q('[data-bl-pack-ud]')) q('[data-bl-pack-ud]').textContent = dinero(unidad);
          if (q('[data-bl-pack-ahorro]')) q('[data-bl-pack-ahorro]').textContent = dinero(desc);
          if (l.querySelector('input').checked) elegido = { n: n, tot: tot };
        });
        var bp = pp.querySelector('.bl-pp__barra-precio');
        if (bp && elegido) bp.textContent = dinero(elegido.tot) + (elegido.n > 1 ? ' · ' + elegido.n + ' uds' : '');
      }
      if (packs) packs.addEventListener('change', function () { pintaPacks(); });

      /* Variantes */
      var datos = pp.querySelector('[data-bl-variantes]');
      if (!datos) return;
      var variantes = JSON.parse(datos.textContent);
      var form = pp.querySelector('form[action*="/cart/add"]');
      var inputId = form ? form.querySelector('input[name="id"]') : null;
      var boton = pp.querySelector('[data-bl-boton]');
      var botonTxt = boton ? boton.querySelector('[data-bl-boton-texto]') : null;
      var precio = pp.querySelectorAll('[data-bl-precio]');
      var antes = pp.querySelectorAll('[data-bl-precio-antes]');
      var ahorro = pp.querySelector('[data-bl-ahorro]');
      var etiquetas = pp.querySelectorAll('[data-bl-opcion-actual]');
      var txtComprar = pp.getAttribute('data-bl-txt-comprar');
      var txtAgotado = pp.getAttribute('data-bl-txt-agotado');
      function seleccion() {
        var opts = [];
        pp.querySelectorAll('[data-bl-opcion]').forEach(function (fs) {
          var pos = parseInt(fs.getAttribute('data-bl-opcion'), 10);
          var marcado = fs.querySelector('input:checked');
          opts[pos] = marcado ? marcado.value : null;
        });
        return opts;
      }
      function actualiza() {
        var sel = seleccion();
        var nombres = [];
        pp.querySelectorAll('[data-bl-opcion]').forEach(function (fs) {
          var m = fs.querySelector('input:checked');
          nombres[parseInt(fs.getAttribute('data-bl-opcion'), 10)] = m ? (m.getAttribute('data-label') || m.value) : '';
        });
        var v = variantes.find(function (va) {
          return va.options.every(function (o, i) { return sel[i] == null || sel[i] === o; });
        });
        etiquetas.forEach(function (et) {
          var pos = parseInt(et.getAttribute('data-bl-opcion-actual'), 10);
          et.textContent = nombres[pos] || '';
        });
        if (!v) {
          if (boton) boton.disabled = true;
          var cy = pp.querySelector('[data-bl-comprar-ya]');
          if (cy) cy.disabled = true;
          if (botonTxt) botonTxt.textContent = txtAgotado;
          return;
        }
        if (inputId) inputId.value = v.id;
        precio.forEach(function (p) { p.textContent = dinero(v.price); });
        var hayAntes = v.compare_at_price && v.compare_at_price > v.price;
        antes.forEach(function (a) { a.textContent = hayAntes ? dinero(v.compare_at_price) : ''; a.hidden = !hayAntes; });
        if (ahorro) {
          ahorro.hidden = !hayAntes;
          if (hayAntes) ahorro.textContent = '-' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%';
        }
        if (boton) boton.disabled = !v.available;
        var comprarYa = pp.querySelector('[data-bl-comprar-ya]');
        if (comprarYa) comprarYa.disabled = !v.available;
        if (botonTxt) botonTxt.textContent = v.available ? txtComprar : txtAgotado;
        pintaPacks(v.price);
        if (v.featured_media_index != null) verFoto(v.featured_media_index);
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
      pp.querySelectorAll('[data-bl-opcion] input').forEach(function (inp) { inp.addEventListener('change', actualiza); });

      /* Añadir al carrito sin salir de la página (abre el carrito lateral de Dawn) */
      if (form) {
        form.addEventListener('submit', function (ev) {
          if (ev.submitter && ev.submitter.hasAttribute('data-bl-comprar-ya')) return;
          var drawer = document.querySelector('cart-drawer');
          if (!drawer || !window.fetch) return;
          ev.preventDefault();
          if (boton) boton.setAttribute('aria-busy', 'true');
          var fd = new FormData(form);
          fd.append('sections', 'cart-drawer,cart-icon-bubble');
          fd.append('sections_url', window.location.pathname);
          fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
            method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd
          }).then(function (r) { return r.json(); }).then(function (res) {
            if (res.status) { form.submit(); return; }
            if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
            if (typeof drawer.renderContents === 'function') { drawer.renderContents(res); }
            else { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; }
          }).catch(function () { form.submit(); })
            .finally(function () { if (boton) boton.removeAttribute('aria-busy'); });
        });
      }

      /* Barra fija de compra en móvil */
      var barra = pp.querySelector('.bl-pp__barra');
      if (barra && boton && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            var pasado = !e.isIntersecting && e.boundingClientRect.top < 0;
            barra.classList.toggle('is-visible', pasado);
          });
        });
        io.observe(boton);
        var btnBarra = barra.querySelector('button');
        if (btnBarra) btnBarra.addEventListener('click', function () {
          if (form && typeof form.requestSubmit === 'function') form.requestSubmit(); else if (boton) boton.click();
        });
      }
    });
  }

  /* ---------- Cesta: botón "+ Añadir otra" del aviso de packs ---------- */
  document.addEventListener('submit', function (ev) {
    var f = ev.target;
    if (!f.matches || !f.matches('[data-bl-mas]')) return;
    var drawer = f.closest('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function' || !window.fetch) return;
    ev.preventDefault();
    var fd = new FormData(f);
    fd.delete('return_to');
    fd.append('sections', 'cart-drawer,cart-icon-bubble');
    fd.append('sections_url', window.location.pathname);
    fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
      method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status) { f.submit(); return; }
      drawer.renderContents(res);
    }).catch(function () { f.submit(); });
  });

  /* ---------- Ventana de bienvenida con el 10 % ---------- */
  function initPopup() {
    var pop = document.querySelector('[data-bl-popup]');
    if (!pop) return;
    var guarda = function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} };
    var lee = function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } };
    var caja = pop.querySelector('.bl-popup__caja');
    var abierta = false;
    var yaSalio = false; /* la apertura automática solo ocurre una vez */
    var pestana = document.querySelector('[data-bl-popup-pestana]');
    function verPestana(si) { if (pestana) pestana.hidden = !si; }

    function abre() {
      if (abierta) return;
      abierta = true;
      yaSalio = true;
      verPestana(false);
      pop.hidden = false;
      requestAnimationFrame(function () { pop.classList.add('is-abierta'); });
      var campo = pop.querySelector('input[type="email"]');
      if (campo && !window.matchMedia('(hover: none)').matches) setTimeout(function () { campo.focus(); }, 350);
      try { sessionStorage.setItem('bl_popup_visto', '1'); } catch (e) {}
    }
    function cierra() {
      pop.classList.remove('is-abierta');
      setTimeout(function () { pop.hidden = true; }, 300);
      abierta = false;
      if (!pop.querySelector('[data-bl-popup-ok]')) {
        guarda('bl_popup_cerrado', String(Date.now()));
        try { if (!sessionStorage.getItem('bl_pestana_no')) verPestana(true); } catch (e) { verPestana(true); }
      }
    }
    /* Pestaña "10 %" para abrirla cuando el cliente quiera, después de haberla cerrado */
    if (pestana) {
      var abrirP = pestana.querySelector('[data-bl-pestana-abrir]');
      var quitarP = pestana.querySelector('[data-bl-pestana-quitar]');
      if (abrirP) abrirP.addEventListener('click', abre);
      if (quitarP) quitarP.addEventListener('click', function () { verPestana(false); try { sessionStorage.setItem('bl_pestana_no', '1'); } catch (e) {} });
    }
    pop.querySelectorAll('[data-bl-popup-cerrar]').forEach(function (b) { b.addEventListener('click', cierra); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && abierta) cierra(); });

    var copiar = pop.querySelector('[data-bl-copiar]');
    if (copiar) copiar.addEventListener('click', function () {
      var c = copiar.getAttribute('data-bl-copiar');
      var ok = function () { copiar.classList.add('is-copiado'); var t = copiar.querySelector('span'); if (t) t.textContent = '¡Copiado!'; };
      if (navigator.clipboard) navigator.clipboard.writeText(c).then(ok, ok); else ok();
    });

    /* Recién enviado (o con error): se abre directamente */
    if (pop.querySelector('[data-bl-popup-ok]')) {
      guarda('bl_popup_ok', '1');
      if (/customer_posted=true/.test(location.search)) abre();
      return;
    }
    if (location.hash === '#bl-popup-form') { abre(); return; }

    if (pop.hasAttribute('data-editor')) return;
    if (lee('bl_popup_ok')) return;
    var cerrado = parseInt(lee('bl_popup_cerrado') || '0', 10);
    var pestanaNo = false;
    try { pestanaNo = !!sessionStorage.getItem('bl_pestana_no'); } catch (e) {}
    if (cerrado) { if (!pestanaNo) verPestana(true); return; } /* ya la cerró una vez: no se vuelve a abrir sola */
    try { if (sessionStorage.getItem('bl_popup_visto')) { if (!pestanaNo) verPestana(true); return; } } catch (e) {}
    if (/^\/(cart|account|policies|pages\/politica)/.test(location.pathname)) return;

    /* Espera a que no se vea el aviso de cookies de Shopify */
    function banner() {
      var b = document.getElementById('shopify-pc__banner');
      if (!b) return false;
      var cs = getComputedStyle(b), r = b.getBoundingClientRect();
      return cs.display !== 'none' && cs.visibility !== 'hidden' && cs.opacity !== '0' && r.height > 0;
    }
    function intenta() { if (abierta || yaSalio) return; if (banner()) { setTimeout(intenta, 2000); return; } abre(); }

    var retraso = (parseFloat(pop.getAttribute('data-retraso')) || 10) * 1000;
    var listo = false;
    setTimeout(function () { listo = true; }, 4000);
    setTimeout(intenta, retraso);
    /* Intención de salida en ordenador: el ratón sale por arriba */
    document.addEventListener('mouseout', function (e) { if (listo && !e.relatedTarget && e.clientY <= 0) intenta(); });
    /* En móvil: al bajar más de la mitad de la página */
    window.addEventListener('scroll', function () {
      if (!listo) return;
      var h = document.documentElement;
      if (h.scrollTop + window.innerHeight > h.scrollHeight * 0.55) intenta();
    }, { passive: true });
  }

  /* ---------- Asistente Briluna (respuestas rápidas, sin IA) ---------- */
  function initAsistente() {
    var asis = document.querySelector('[data-bl-asis]');
    if (!asis || asis.hasAttribute('data-listo')) return;
    asis.setAttribute('data-listo', '');
    var datos = JSON.parse(asis.querySelector('[data-bl-asis-datos]').textContent);
    var panel = asis.querySelector('.bl-asis__panel');
    var abrir = asis.querySelector('[data-bl-asis-abrir]');
    var mensajes = asis.querySelector('[data-bl-asis-mensajes]');
    var form = asis.querySelector('[data-bl-asis-form]');
    var campo = form.querySelector('input');
    var norm = function (s) {
      return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9ñ ]+/g, ' ').replace(/\s+/g, ' ').trim();
    };
    /* Palabras clave: "!" al final = palabra concreta, pesa más que las generales */
    var claves = datos.respuestas.map(function (r) {
      return (r.k || '').split(',').map(function (k) {
        var fuerte = /!\s*$/.test(k);
        return { t: norm(k.replace(/!\s*$/, '')), w: fuerte ? 3 : 1 };
      }).filter(function (k) { return k.t; });
    });

    function abre() {
      panel.hidden = false;
      abrir.setAttribute('aria-expanded', 'true');
      asis.classList.add('is-abierto');
      if (!window.matchMedia('(hover: none)').matches) setTimeout(function () { campo.focus(); }, 200);
    }
    function cierra() {
      panel.hidden = true;
      abrir.setAttribute('aria-expanded', 'false');
      asis.classList.remove('is-abierto');
    }
    abrir.addEventListener('click', function () { panel.hidden ? abre() : cierra(); });
    asis.querySelector('[data-bl-asis-cerrar]').addEventListener('click', cierra);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) cierra(); });

    function burbuja(html, quien) {
      var d = document.createElement('div');
      d.className = 'bl-asis__msg bl-asis__msg--' + quien;
      if (quien === 'yo') d.textContent = html; else d.innerHTML = html;
      mensajes.appendChild(d);
      mensajes.scrollTop = mensajes.scrollHeight;
      return d;
    }
    function responde(html) {
      var escribiendo = burbuja('<span class="bl-asis__puntos"><i></i><i></i><i></i></span>', 'bot');
      setTimeout(function () {
        escribiendo.innerHTML = html;
        if (datos.otraDuda) burbuja('<p>' + datos.otraDuda + '</p>', 'bot');
        mensajes.scrollTop = mensajes.scrollHeight;
      }, 450);
    }
    /* Busca la respuesta que más palabras de la pregunta reconoce (cada palabra cuenta una vez, con su peso;
       las frases de varias palabras suman uno más) */
    function busca(texto) {
      var q = ' ' + norm(texto) + ' ';
      var mejor = -1, puntos = 0;
      claves.forEach(function (lista, i) {
        var usadas = {}, p = 0;
        lista.forEach(function (k) {
          var pos = q.indexOf(' ' + k.t);
          if (pos === -1 || usadas[pos]) return;
          usadas[pos] = true;
          p += k.w + (k.t.indexOf(' ') !== -1 ? 1 : 0);
        });
        if (p > puntos) { puntos = p; mejor = i; }
      });
      return mejor;
    }
    asis.querySelectorAll('[data-bl-asis-chip]').forEach(function (b) {
      b.addEventListener('click', function () {
        var r = datos.respuestas[parseInt(b.getAttribute('data-bl-asis-chip'), 10)];
        if (!r) return;
        burbuja(r.p, 'yo');
        responde(r.r);
      });
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var t = campo.value.trim();
      if (!t) return;
      campo.value = '';
      burbuja(t, 'yo');
      var i = busca(t);
      responde(i >= 0 ? datos.respuestas[i].r : datos.sinRespuesta);
    });
  }

  function initTodo(root) {
    initReveal(root); initCifras(root); initEscenas(root); initHero(root); initProducto(root);
    if (!root) { initPopup(); initAsistente(); }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initTodo(); });
  else initTodo();

  /* Editor de Shopify: re-inicializar al añadir/editar secciones */
  document.addEventListener('shopify:section:load', function (e) { initTodo(e.target); });
})();
